export const NOTIFICATIONS = {
  GET_NOTIFICATIONS: 'GET_NOTIFICATIONS',
  GET_NOTIFICATIONS_COUNT: 'GET_NOTIFICATIONS_COUNT',
  NOTIFICATIONS_TIME_OUT: 3000,

  ACTION_TYPE: {
    DISPLAY_ONLY: '0',
    ACTION_REQUIRED: '1',
    ACCEPT_LEAD: '2',
    CONFIRM_APPOINTMENT: '3',
    APPOINTMENT_OUTCOME: '4', // TODO: may need name change to CompleteAppointment
    WEEKLY_STATUS_UPDATE: '5',
    MADE_CONTACT: '6', // used for indicating action required for contacting lead
    OPPORTUNITY_CLOSED: '7',
    NEW_TASK: '8',
    COMPLETE_TASK: '9',
    APPOINTMENT_REMINDER: '10',
    AUTOASSIGN_LEADACCEPTANCE: '11',
    DOCUMENT_REJECTED: '12',
    ACCEPT_LEAD_DIRECT_ROUTE: 'ACCEPT_LEAD_DIRECT_ROUTE'
  },

  OBJECT_TYPE: {
    UNDEFINED: 0,
    OPPORTUNITY: 1,
    APPOINTMENT: 2,
    TASK: 3
  }
};
